/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Long, thin, light freight is hand-offloaded rather than ridden up the liftgate platform, so it
 * is exempt from both the liftgate dimension cap and the liftgate weight cap. This exception is
 * universal across all carriers because the freight never touches the liftgate. An item qualifies
 * when, with its three axes sorted descending, the longest is at most maxLengthInches, the
 * second-largest is at most maxSecondAxisInches, and its per-handling-unit weight is at most
 * maxWeightPerHandlingUnitPounds.
 * 
 * @export
 * @interface ShipmentLimitsLiftgateLongThinException
 */
export interface ShipmentLimitsLiftgateLongThinException {
    /**
     * 
     * @type {number}
     * @memberof ShipmentLimitsLiftgateLongThinException
     */
    maxLengthInches: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentLimitsLiftgateLongThinException
     */
    maxSecondAxisInches: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentLimitsLiftgateLongThinException
     */
    maxWeightPerHandlingUnitPounds: number;
}

/**
 * Check if a given object implements the ShipmentLimitsLiftgateLongThinException interface.
 */
export function instanceOfShipmentLimitsLiftgateLongThinException(value: object): value is ShipmentLimitsLiftgateLongThinException {
    if (!('maxLengthInches' in value) || value['maxLengthInches'] === undefined) return false;
    if (!('maxSecondAxisInches' in value) || value['maxSecondAxisInches'] === undefined) return false;
    if (!('maxWeightPerHandlingUnitPounds' in value) || value['maxWeightPerHandlingUnitPounds'] === undefined) return false;
    return true;
}

export function ShipmentLimitsLiftgateLongThinExceptionFromJSON(json: any): ShipmentLimitsLiftgateLongThinException {
    return ShipmentLimitsLiftgateLongThinExceptionFromJSONTyped(json, false);
}

export function ShipmentLimitsLiftgateLongThinExceptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipmentLimitsLiftgateLongThinException {
    if (json == null) {
        return json;
    }
    return {
        
        'maxLengthInches': json['maxLengthInches'],
        'maxSecondAxisInches': json['maxSecondAxisInches'],
        'maxWeightPerHandlingUnitPounds': json['maxWeightPerHandlingUnitPounds'],
    };
}

  export function ShipmentLimitsLiftgateLongThinExceptionToJSON(json: any): ShipmentLimitsLiftgateLongThinException {
      return ShipmentLimitsLiftgateLongThinExceptionToJSONTyped(json, false);
  }

  export function ShipmentLimitsLiftgateLongThinExceptionToJSONTyped(value?: ShipmentLimitsLiftgateLongThinException | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'maxLengthInches': value['maxLengthInches'],
        'maxSecondAxisInches': value['maxSecondAxisInches'],
        'maxWeightPerHandlingUnitPounds': value['maxWeightPerHandlingUnitPounds'],
    };
}

